import type { RouteTab } from "@/pages/analytics/shared";

export const PRODUCT_RECORDS_PATH = "/analytics/product";

/**
 * Today's nine tabs, unchanged (report ch.6 change 1): each slug is the pre-split `eventKey` and
 * each label its title. The FR-ADM-02 renames ship later as their own change, with redirects from
 * these slugs (OI-ANL-112). `src/common/routes/index.tsx` registers the same slugs, in this order.
 */
export const PRODUCT_RECORDS_TABS = [
  { slug: "overview", label: "Overview" },
  { slug: "discover", label: "Discovery" },
  { slug: "events", label: "Events" },
  { slug: "wishlist", label: "Wishlist" },
  { slug: "event-products", label: "Event products" },
  { slug: "gift-splits", label: "Gift splits" },
  { slug: "mobile", label: "Mobile analytics" },
  { slug: "friends", label: "Friends" },
  { slug: "badges", label: "Badges" },
] as const;

export const PRODUCT_RECORDS_ROUTE_TABS: RouteTab[] = PRODUCT_RECORDS_TABS.map(
  ({ slug, label }) => ({ label, path: `${PRODUCT_RECORDS_PATH}/${slug}` }),
);
